module.exports = __webpack_public_path__ + "assets/TrapezoidCut3.450ebac1d82e066c2cb4bfeae43591e0.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/TrapezoidCut3.gmt
// module id = 1025
// module chunks = 0